<div class="free-content">
  <div class="free-content-menu-wrapper">
    <div class="free-content-menucombo-wrapper" mat-button [matMenuTriggerFor]="menu">
      <button class="side-menu-button">
        <img src="{{ activeComponent.iconPath }}" />
        {{ activeComponent.title }}
      </button>
      <mat-icon class="free-content-menucombo-icon">expand_more</mat-icon>
    </div>
    <mat-menu #menu="matMenu">
      <div class="side-menu-wrapper side-menu-wrapper-combo">
        @for (tab of tabs; track tab; let isLast = $last) {
          <div
            mat-menu-item
            [ngClass]="tab.isTabGroup ? 'side-menu-group' : 'side-menu-nogroup'"
            [class.last-item]="isLast"
            [disableRipple]="true"
            >
            @if (tab.groupTitle.length > 0) {
              <div class="side-menu-wrapper-title">{{ tab.groupTitle }}</div>
            }
            <button [ngClass]="{ active: tab === activeComponent }" class="side-menu-button" (click)="comboItemClick(tab)">
              <img src="{{ tab.iconPath }}" />
              {{ tab.title }}
            </button>
          </div>
        }
      </div>
    </mat-menu>

    <div class="side-menu-wrapper">
      @for (tab of tabs; track tab) {
        <div [ngClass]="tab.isTabGroup ? 'side-menu-group' : 'side-menu-nogroup'">
          @if (tab.groupTitle.length > 0) {
            <div class="side-menu-wrapper-title">{{ tab.groupTitle }}</div>
          }
          <button [ngClass]="{ active: tab === activeComponent }" class="side-menu-button" (click)="activateTab(tab)">
            <img src="{{ tab.iconPath }}" />
            {{ tab.title }}
          </button>
        </div>
      }
    </div>
  </div>

  <div class="side-menu-content">
    <ng-template [ngTemplateOutlet]="activeComponent.templateRef"></ng-template>
  </div>
</div>
